import React, { useEffect, useState } from 'react'

import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'

import CloseIconWhite from 'src/Assets/Svg/closeWhite.svg?react'
import { locationEvent, pageViewEvent } from 'src/Helpers/TagManager'
import LogoIcon from 'src/Assets/Svg/Logo/Logo.svg?react'
import LogoTextIcon from 'src/Assets/Svg/Logo/LogoText.svg?react'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { pageInfo } from 'src/Helpers/TagManager/pageInfo'

import { validateRegisterStatus } from './helpers/validateRegisterStatus'
import { LoginCreator } from './components/LoginCreator/LoginCreator'
import { LoginCreatorConnect } from './components/LoginCreatorConnect/LoginCreatorConnect'
import { LoginCreatorConnected } from './components/LoginCreatorConnected/LoginCreatorConnected'
import { LoginCreatorFrom } from './components/LoginCreatorForm/LoginCreatorFrom'
import { LoginCreatorCompleted } from './components/LoginCreatorCompleted/LoginCreatorCompleted'

import { Header, LoginFieldsWrapper, MainWrapper } from './styles'

export const CloseButton = styled.button`
  cursor: pointer;
  position: absolute;
  background-color: transparent;
  display: flex;
  height: 40px;
  width: 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  top: 16px;
  right: 16px;
  & svg {
    width: 16px;
    height: 16px;
    path {
      fill: ${({ theme }) => theme.color.slateGrey}!important;
    }
  }
`

const Registration: React.FC = () => {
  const { search } = useCustomSearchParams()
  const navigate = useNavigate()
  const status = search.get('status') || ''

  const [registerState, setRegisterState] = useState(
    validateRegisterStatus(status),
  )

  const handleButtonClick = (): void => {
    navigate('/')
  }

  useEffect(() => {
    locationEvent()
    pageViewEvent({ currentPageInfo: pageInfo.signupCreator })
  }, [])

  return (
    <MainWrapper>
      <CloseButton data-testid='close-button' onClick={handleButtonClick}>
        <CloseIconWhite />
      </CloseButton>
      <Header>
        <LogoIcon data-testid='logo' />
        <LogoTextIcon />
      </Header>

      <LoginFieldsWrapper>
        <LoginCreator status={registerState} />
        <LoginCreatorConnect status={registerState} />
        <LoginCreatorConnected
          status={registerState}
          setRegisterState={setRegisterState}
        />
        <LoginCreatorFrom
          status={registerState}
          setRegisterState={setRegisterState}
        />
        <LoginCreatorCompleted status={registerState} />
      </LoginFieldsWrapper>
    </MainWrapper>
  )
}

export default Registration
